export default __webpack_public_path__ + "static/media/icon-success-o-large.b774e428.svg";